import { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const ChannelContext = createContext({
  channel: 'dreams_league',
  label: 'Dreams League',
  basePath: '',
  accent: 'blue',
});

// Channel metadata
export const CHANNELS = {
  dreams_league: {
    id: 'dreams_league',
    label: 'Dreams League',
    short: 'LEAGUE',
    basePath: '',
    accent: 'blue',
    accentClass: 'blue-gradient',
    accentHex: '#4a9edd',
    theme: 'light',
    hasNetwork: true,
    networkPath: '/network',
    networkLabel: 'Dreams League Network',
    networkBlurb: 'Athlete sit-downs, brand drops, and the moments no one else captures.',
    voicesLabel: 'Athletes',
    voicesPath: '/athletes',
    storiesPath: '/stories',
    homePath: '/',
    aboutPath: '/about',
    contactPath: '/contact',
    tagline: 'Real athletes. Real journeys. Real stories.',
    wordmark: 'DREAMS LEAGUE',
  },
  dreams_visionary: {
    id: 'dreams_visionary',
    label: 'Dreams Visionaries',
    short: 'DREAMERS',
    basePath: '/visionary',
    accent: 'visionary',
    accentClass: 'visionary-gradient',
    accentHex: '#0a0a0a',
    theme: 'visionary', // clean B&W theme
    hasNetwork: true,
    networkPath: '/visionary/network',
    networkLabel: 'Dreamers Network',
    networkBlurb: 'Founders, artists, entrepreneurs, pioneers — told without the filter.',
    voicesLabel: 'Visionaries',
    voicesPath: '/visionary/voices',
    storiesPath: '/visionary/stories',
    homePath: '/visionary',
    aboutPath: '/visionary/about',
    contactPath: '/visionary/contact',
    tagline: 'Artists. CEOs. Entrepreneurs. Pioneers.',
    wordmark: 'DREAMS VISIONARIES',
  },
  flyt: {
    id: 'flyt',
    label: 'Studio',
    short: 'STUDIO',
    basePath: '/flyt',
    accent: 'gold',
    accentClass: 'gold-gradient',
    accentHex: '#D4AF37',
    theme: 'dark',
    hasNetwork: false,
    networkPath: null,
    networkLabel: null,
    networkBlurb: null,
    voicesLabel: 'Voices',
    voicesPath: '/flyt/voices',
    storiesPath: '/flyt/stories',
    homePath: '/flyt',
    aboutPath: '/flyt/about',
    contactPath: '/flyt/contact',
    tagline: 'The studio that creates the Dreams League stories.',
    wordmark: 'FLYT STUDIOS',
  },
};

export const ChannelProvider = ({ children }) => {
  const location = useLocation();

  const channel = useMemo(() => {
    if (location.pathname.startsWith('/flyt')) return CHANNELS.flyt;
    if (location.pathname.startsWith('/visionary')) return CHANNELS.dreams_visionary;
    return CHANNELS.dreams_league;
  }, [location.pathname]);

  return (
    <ChannelContext.Provider value={channel}>
      {children}
    </ChannelContext.Provider>
  );
};

export const useChannel = () => useContext(ChannelContext);

export default ChannelContext;
